<template>
  <div class="config">
    <div>
      <label for="questionId">Question ID:</label>
      <input type="text" id="questionId" v-model="metabase.question"/>
      <button type="button" class="btn btn-primary btn-sm" @click="$parent.addCard(getFullCard())" :disabled="!isValid(metabase.question)">Add</button>
    </div>

    <p class="form-text">
      Before adding a Lens question to your dashboard, ensure that it is published
      <span id="popover-target" class="fa fa-question-circle" />
      <b-popover placement="right" target="popover-target" triggers="hover" title="Publishing">
        To learn how to publish a lens question, go to
        <a
          href="https://waytohealth.atlassian.net/wiki/spaces/WTHST/pages/2237333505/Creating+and+publishing+questions"
          target="_blank"
        ><strong>our documentation</strong></a>
      </b-popover>
    </p>

    <div>
      <label class="input-toggle">
        <input v-model="metabase.studyLock" type="checkbox">
        <span class="toggle-slider" />
        Lock to study <span v-if="metabase.studyLock" class="badge badge-warning">(Requires question to have "studyId" parameter)</span>
      </label>
    </div>

<!--    <div class="parameters">-->
<!--      <div>-->
<!--        <button type="button" class="btn btn-default btn-sm" @click="addParameter()" >Add Parameter</button>-->
<!--      </div>-->
<!--      <ul v-if="metabase.parameters.length > 0" class="list-unstyled">-->
<!--        <li v-for="(param, i) in metabase.parameters">-->
<!--          <div>-->
<!--            <label>Name:</label><input type="text" v-model="param.name"/>-->
<!--            <label>Value: </label><input type="text" v-model="param.value"/>-->
<!--            <button type="button" class="btn btn-danger btn-sm" @click="removeParameter(i)" ><span class="fa fa-trash" /></button>-->
<!--          </div>-->
<!--        </li>-->
<!--      </ul>-->
<!--    </div>-->



  </div>
</template>

<script>
  import { BPopover } from "bootstrap-vue";

  export default {
    components: {
      BPopover,
    },
    props: {
      value: {
        type: Object,
        required: true,
      }
    },
    data() {
      return {
        card: Object.assign(this.value, {
          label: 'Lens Question',
          type: 'MetabaseWidget',
          h: 6,
          w: 8
        }),
        metabase: {
          question: null,
          studyLock: false,
          parameters: []
        }
      }
    },
    methods: {
      isValid: function(question) {
        var validQuestion = question && !isNaN(question);

        var validParams = true;

        this.metabase.parameters.forEach(function (param) {
          if (!param.name || !param.value) {
            validParams = false;
          }
        })
        return validQuestion && validParams;
      },
      getFullCard: function() {
        return Object.assign(this.card, {"metabase" : this.metabase});
      },
      // addParameter() {
      //   this.metabase.parameters.push({
      //     name: '',
      //     value: '',
      //   });
      // },
      // removeParameter(i) {
      //   this.metabase.parameters.splice(i, 1);
      // }
    }
  }
</script>

<style scoped>
  .config {
    margin-top: 10px;
  }

  .parameters {
    margin-top: 10px;
    margin-left: 20px;
  }

  ul {
    margin-top: 5px;
  }

  li {
    margin-top: 5px;
  }
</style>